import { render, staticRenderFns } from "./SlideshowPage.vue?vue&type=template&id=7ccd36f2"
import script from "./SlideshowPage.vue?vue&type=script&lang=js"
export * from "./SlideshowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports